import { render, staticRenderFns } from "./OrgConnectivityConfigModal.vue?vue&type=template&id=31779780"
import script from "./OrgConnectivityConfigModal.vue?vue&type=script&lang=js"
export * from "./OrgConnectivityConfigModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports